import OMobileMapModal from './o-mobile-map-modal.vue';

export default OMobileMapModal;